import ArrowDown from '@mui/icons-material/ArrowDownward';
import ArrowUp from '@mui/icons-material/ArrowUpward';
import {Icon, IconButton, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {SORT_DIRECTIONS} from '../../constants/index.js';

const SortButton = props => {
  const {t} = useTranslation();
  const onSortClick = () => {
    // Toggle sort direction
    const direction =
      props.sortDirection === SORT_DIRECTIONS.DSC
        ? SORT_DIRECTIONS.ASC
        : SORT_DIRECTIONS.DSC;

    props.setDirection(direction);
  };

  return (
    <Tooltip
      title={
        props.sortDirection === SORT_DIRECTIONS.DSC
          ? t('resultsList.tooltipSortedNewest')
          : t('resultsList.tooltipSortedOldest')
      }
    >
      <IconButton size="small" onClick={onSortClick} data-qe="sort-button">
        <Icon
          color="action"
          component={
            props.sortDirection === SORT_DIRECTIONS.DSC ? ArrowDown : ArrowUp
          }
        />
      </IconButton>
    </Tooltip>
  );
};

SortButton.propTypes = {
  sortDirection: PropTypes.string,
  setDirection: PropTypes.func,
};

export default SortButton;
